<template>
  <span>
    <b-dropdown variant="none" :disabled="disabled">
      <template #button-content>
        <div class="dropdown-btn">
          <question-category  :label="label"  :status="selectedItem.definition" :alt="selected" />
        </div>
      </template>
      <b-dropdown-item v-for="item in options" :key="'status-' + item.definition" @click="itemSelected(item)" :disabled="item.definition == selectedItem.definition">
        <question-category :status="item.definition" :label="label" :onlyDot="true" />

     {{ item.name | translate }}
      </b-dropdown-item>
    </b-dropdown>
  </span>
</template>

<script>
import QuestionCategory from "@cc/question-category";
export default {
  components: { QuestionCategory },
  props: ["selected", "disabled", "label"],

  computed: {
    options() {
      const language = this.currentLanguage;
      return [
        {
          definition: "TEST",
          name: {
            [language]: this.$t("firm.status.test"),
          },
        },
        {
          definition: "PROD",
          name: {
            [language]: this.$t("firm.status.prod"),
          },
        },

        {
          definition: "POST_PROD",
          name: {
            [language]: this.$t("firm.status.post-prod"),
          },
        },
      ];
    },

    selectedItem() {
      // const language = this.currentLanguage;

      return this.options.find((i) => i.definition == this.selected) 
    },
  },
  watch: {
    selected(v) {},
  },
  mounted() {},
  methods: {
    itemSelected(item) {
      this.selected = item.definition;
      if (item) {
        this.$emit("onSelect", item.definition);
      } else {
        this.$emit("onSelect", "TEST");
      }
    },
  },
};
</script>

<style>
.multiselect-wrapper .multiselect__option--highlight {
  background: rgb(237, 237, 237) !important;
  color: black !important;
}
.btn-none {
  padding: 0px;
}
</style>
